module.exports = __webpack_public_path__ + "img/bluedownarrow.37ec2d54.svg";